import React from 'react';
import { connect } from 'react-redux';

import { Form } from 'components/common';
import MainFieldSet from './MainFieldSet';

const NavTopForm = (props) => {
  const { showEditForm } = props.navTop;

  const onClose = () => {
    props.actions.navTop.showEditForm({ show: false });
  };

  const onSubmit = (data) => {
    const newData = Object.assign(data, {
      site: props.site.activeId,
      page: data.page ? data.page: null,
    });
    props.actions.navTop.update(newData);
  };

  return (
    <Form
      width={800}
      name="NavTopForm"
      title="Редактирование навигации"
      model={props.navTop}
      visible={showEditForm}
      onClose={onClose}
      onSubmit={onSubmit}
      initialValues={{ sort: 100 }}
      convertEditObject={(editObject) => ({
        ...editObject,
        page: editObject.page ? editObject.page.id: null,
      })}
    >
      <MainFieldSet {...props} />
    </Form>
  );
};

const mapState = (state) => ({
  site: state.site,
  auth_token: state.auth.token,
  navTop: state.navTop,
});

const mapDispatch = (dispatch) => ({
  actions: {
    navTop: dispatch.navTop,
  },
});

export default connect(mapState, mapDispatch)(NavTopForm);
